import {
    UNSUPPORTED_FOR_IMPORT_COLUMN_TYPES,
    UNSUPPORTED_FOR_IMPORT_ROW_TYPES,
} from '../components/annotations/constants';
import { COLUMN_TYPE, FORMAT, MATCHING_TIME_PERIODS } from '../constants/generalConstants';
import { ColumnMetadataType, ReportPropsType, RowMetadataType, TableIdType } from '../types';

export function getDefaultReportProps(colsMetadata?: ColumnMetadataType[]): ReportPropsType {
    let result: ReportPropsType = {
        year: undefined,
        period: undefined,
        version: undefined,
        format: FORMAT.STANDARD,
        scale: undefined,
    };
    const reportColumn = colsMetadata?.find((x) => x.contentType === COLUMN_TYPE.REPORT);
    if (reportColumn && reportColumn.reportProps) {
        const reportProps = reportColumn.reportProps;

        let period = undefined;

        if (reportProps.period) {
            const reportPeriod = reportProps.period;
            const matchingPeriods = MATCHING_TIME_PERIODS.find((matchingPeriods) =>
                matchingPeriods.includes(reportPeriod)
            );

            if (matchingPeriods) {
                period = matchingPeriods.filter((p) => p !== reportPeriod)[0];
            }
        }
        result = { ...result, ...reportProps, period };
    }

    return result;
}

export function allPossibleImportCandidateRowsSelected(rowsMetadata: RowMetadataType[], tableId: TableIdType) {
    const candidates = rowsMetadata
        .filter((row) => row.rowId.includes(tableId))
        .filter((row) => !UNSUPPORTED_FOR_IMPORT_ROW_TYPES.includes(row.contentType));
    return candidates.length ? candidates.every((row) => row.importCandidate)   : false;
}

export function allPossibleImportCandidateColumnsSelected(colsMetadata: ColumnMetadataType[], tableId: TableIdType) {
    const candidates = colsMetadata
        .filter((col) => col.colId.includes(tableId))
        .filter((col) => !UNSUPPORTED_FOR_IMPORT_COLUMN_TYPES.includes(col.contentType));

    return candidates.length ? candidates.every((col) => col.importCandidate)   : false;
}
